import {
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core";
import {
  countOrACVFormatter,
  customDateFormatter,
  formatDateTimeUTC,
  StyledTableRow,
} from "../../util/customFunctions";
import MarketingSupportRequestsTableCopy from "../../components/xlsx-export/MarketingSupportRequestsCopyTableComponent";

const useStyles = makeStyles(
  (theme) => ({
    root: {
      margin: "0.5rem",
      padding: "0.5rem",
    },
    sticky: {
      position: "sticky",
      left: -1,
      background: "white",
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        width: "0.5px",
        background: "lightgrey",
      },
    },
    colHeaderNew: {
      fontSize: "0.85rem",
      border: "0.5px solid lightgrey",
      padding: "7px 10px",
      color: "inherit",
      fontWeight: "inherit",
      backgroundColor: "inherit",
    },
    colHeader: {
      fontSize: "0.85rem",
      border: "0.5px solid lightgrey",
      padding: "7px 10px",
      color: "inherit",
      fontWeight: 600,
      cursor: "pointer",
    },
    dataCell: {
      fontSize: "0.85rem",
      border: "0.5px solid lightgrey",
      padding: "7px 10px",
      color: "inherit",
      fontWeight: "inherit",
      // width: '120px'
    },
    dataCell2: {
      fontSize: "0.85rem",
      border: "0.5px solid lightgrey",
      padding: "7px 10px",
      color: "inherit",
      fontWeight: "inherit",
    },
    drilldownCell: {
      fontSize: "0.85rem",
      border: "0.5px solid lightgrey",
      padding: "7px 10px",
      color: "inherit",
      fontWeight: "inherit",
      cursor: "pointer",
    },
    drilldownCellNQP: {
      fontSize: "0.85rem",
      border: "0.5px solid lightgrey",
      padding: "7px 10px",
      color: "inherit",
      width: "3%",
      fontWeight: "inherit",
      cursor: "pointer",
    },
    cellMargin: {
      fontSize: "0.85rem",
      border: "0.5px solid lightgrey",
      padding: "7px 10px",
      color: "inherit",
      fontWeight: "inherit",
      paddingLeft: "2rem",
    },
    fontBold: {
      fontWeight: 600,
    },
    indentName: {
      paddingLeft: 30,
    },
    noBorder: {
      border: "none",
    },
    primaryColumnColor: {
      backgroundColor: "#4472C4",
      color: "white",
    },
  }),
  { index: 1 }
);

function DataTablev4({
  columns,
  data,
  dataTest,
  title,
  font = "h2",
  onDropdownChange,
}) {
  const classes = useStyles();
  const tableRef = useRef();
  const tableContainerRef = useRef();

  const [tableData, setTableData] = useState(data);
  const [updatedRows, setUpdatedRows] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [rowPin, setrowPin] = useState(false);
  const [parentWidth, setparentWidth] = useState();
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    setTableData(data);
  }, [data]);

  useEffect(() => {
    const tableContainer = tableContainerRef.current;

    const handleScroll = () => {
      if (tableContainer.scrollLeft > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
      if (tableContainer.scrollTop > 0) {
        setrowPin(true);
      } else {
        setrowPin(false);
      }
    };

    tableContainer.addEventListener("scroll", handleScroll);

    return () => {
      tableContainer.removeEventListener("scroll", handleScroll);
    };
  }, [classes.sticky]);

  useEffect(() => {
    const parentWidth = tableContainerRef.current.getBoundingClientRect().width;
    setparentWidth(parentWidth);
  }, [parentWidth]);

  // Sorting function
  const handleSort = (columnField) => {
    let direction = "asc";
    if (sortConfig.key === columnField && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedData = [...tableData].sort((a, b) => {
      const valA = a[columnField] || "";
      const valB = b[columnField] || "";

      if (typeof valA === "number" && typeof valB === "number") {
        return direction === "asc" ? valA - valB : valB - valA;
      } else {
        return direction === "asc"
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      }
    });

    setTableData(sortedData);
    setSortConfig({ key: columnField, direction });
  };

  const handleDropdownChange = (e, row, col) => {
    const newValue = e.target.value;

    setTableData((prevData) =>
      prevData.map((r) =>
        r === row
          ? { ...r, [col.field]: { ...r[col.field], value: newValue } }
          : r
      )
    );

    const updatedRow = {
      ...row,
      Status: row.Status.value,
      Outcome: row.Outcome.value,
      newValue,
      oldValue: row[col.field].value,
      field: col.field,
    };

    setUpdatedRows((prevUpdates) => [...prevUpdates, updatedRow]);
  };

  const handleUpdate = () => {
    console.log("Updating Rows:", updatedRows);
    onDropdownChange(updatedRows);
    setUpdatedRows([]);
  };

  return (
    <div
      style={{
        maxWidth: "100%",
        justifyContent: "center",
        padding: "2rem",
        paddingTop: 0,
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          {title ? (
            <Box display="flex" alignItems="center" justifyContent="center">
              <Box
                width={14}
                height={14}
                bgcolor="#F4AB83" // You can customize this
                mr={1} // margin right
              />
              <Typography
                align="center"
                variant={font}
                style={{ fontWeight: 600 }}
              >
                {title}
              </Typography>
            </Box>
          ) : (
            <Typography
              align="center"
              variant={font}
              style={{ fontWeight: 600 }}
            >
              {title}
            </Typography>
          )}
        </Grid>
        <Grid item xs={1} style={{ textAlign: "right" }}>
          <MarketingSupportRequestsTableCopy
            columns={columns}
            tableData={tableData}
          />
        </Grid>
      </Grid>

      <TableContainer
        style={{
          width: "auto",
          borderLeft: isSticky ? "0.5px solid lightgrey" : "",
          borderTop: rowPin ? "0.5px solid lightgrey" : "",
          maxHeight: "75vh",
          paddingBottom: "1rem",
        }}
        id="myTableContainer-Second"
        ref={tableContainerRef}
      >
        <Table ref={tableRef} data-test={dataTest}>
          <TableHead>
            <TableRow>
              <TableCell
                key={"123x123"}
                align="center"
                className={`${classes.sticky} ${classes.colHeader}`}
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 10, // Ensure it stays above other cells when scrolling
                  backgroundColor: "#4471c4",
                  color: "white",
                  cursor: "default",
                }}
              >
                #
              </TableCell>
              {columns.map((col, idx) => (
                <TableCell
                  key={idx}
                  align="center"
                  onClick={() => handleSort(col.field)}
                  className={`${classes.sticky} ${classes.colHeader}`}
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 6, // Ensure it stays above other cells when scrolling
                    backgroundColor: idx % 2 === 0 ? "#5b9bd5" : "#4471c4",
                    color: "white",
                    width: col.label === "Product" && "45rem",
                  }}
                >
                  {col.label}
                  <TableSortLabel
                    active={sortConfig.key === col.field}
                    direction={sortConfig.direction}
                  />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((row, idx) => (
              <StyledTableRow key={idx}>
                <TableCell
                  key={idx}
                  className={classes.dataCell2}
                  align="center"
                  style={{
                    background: row["bg"] && row["bg"],
                    color: row["clr"] && row["clr"],
                  }}
                >
                  {idx + 1}
                </TableCell>
                {columns.map((col, colIdx) => (
                  <TableCell
                    key={colIdx}
                    className={classes.dataCell}
                    align={["string"].includes(col.type) ? "left" : "right"}
                    style={{
                      ...(col.dropdown &&
                        row["Status"].value !== "Request Withdrawn" && {
                          paddingLeft: "5px",
                        }),
                      ...(col.type === "date" && { width: "161px" }),
                      ...(row["bg"] && { background: row["bg"] }),
                    }}
                  >
                    {col.dropdown ? (
                      row["Status"].value === "Request Withdrawn" ? (
                        row[col.field].value || "-"
                      ) : (
                        <select
                          value={row[col.field].value || ""}
                          onChange={(e) => handleDropdownChange(e, row, col)}
                          style={{
                            background: "none",
                            border: "none",
                            fontSize: "0.85rem",
                          }}
                        >
                          {col.field === "Outcome" && <option>-</option>}
                          {row[col.field].values.map((option, index) => (
                            <option
                              key={index}
                              value={option.status || option.Outcome}
                            >
                              {option.status || option.Outcome}
                            </option>
                          ))}
                        </select>
                      )
                    ) : col.type === "date" ? (
                      row[col.field] ? (
                        formatDateTimeUTC(row[col.field])
                      ) : (
                        "-"
                      )
                    ) : col.type === "Progress" ? (
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          justifyContent: "center",
                        }}
                      >
                        {[...Array(8)].map((_, i) => (
                          <div
                            key={i}
                            style={{
                              width: "12px",
                              height: "2px",
                              backgroundColor:
                                row.Progress > i ? "green" : "lightgray",
                              borderRadius: "2px",
                            }}
                          />
                        ))}
                      </div>
                    ) : (
                      row[col.field] || "-"
                    )}
                  </TableCell>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Update Button */}
      <div style={{ textAlign: "left", marginTop: "1rem" }}>
        <Button
          onClick={handleUpdate}
          disabled={updatedRows.length === 0}
          variant="contained"
          color="primary"
          data-test="update Marketing Requests"
        >
          Update
        </Button>
      </div>
    </div>
  );
}

export default DataTablev4;
